<template>
  <div>
    <div class="nav-item show">
      <div class="nav-left">
        <div class="nav-type" v-for="item in categoryList">
          <div class="fl-left">
            <router-link :to="{path:'/list',query:{cate1Id:item.pid,cate2Id:item.id}}" class="fl" @click.native="toChange" >{{ item.cateName }}</router-link>
            <a class="right-icon"></a>
          </div>
          <div class="fl-right" v-if="item.children">
            <ul>
              <li v-for="item2 in item.children">
                <router-link :to="{path:'/list',query:{cate2Id:item2.pid,cate3Id:item2.id}}" @click.native="toChange">{{ item2.cateName }}</router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'i-nav-items',

  props: {
    categoryList: {
      type: [Array],
      default: []
    },
  },
  data() {
    return {}
  },
  methods: {
    toChange(){
      // this.$router.go(0);
    }

  },

}
</script>

<style scoped="scoped" lang="less">

</style>